import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePickerTrans from './components/date-picker-trans/date-picker-trans';
import { localeCode } from '../../helpers/locale-helpers';
import { DATE_OPTIONS } from './components/date-picker-trans/date-picker-constants';

export class DatePicker extends Component {
    static contextTypes = {
        router: PropTypes.object
    };

    static propTypes = {
        academicYear: PropTypes.shape({
            startDate: PropTypes.string,
            endDate: PropTypes.string
        }).isRequired,
        currentDate: PropTypes.shape({
            type: PropTypes.string,
            startDate: PropTypes.string,
            endDate: PropTypes.string
        }).isRequired,
        onDateChange: PropTypes.func.isRequired,
        initialDate: PropTypes.shape({
            startDate: PropTypes.string,
            endDate: PropTypes.string
        }),
        /** Options to display in dropdown menu */
        options: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.oneOf(DATE_OPTIONS)
            }).isRequired
        ).isRequired
    };

    getTranslatedOptions = (options) => {
        const i18n = window.i18n;

        if (i18n) {
            return options.map((item) => {
                const label = i18n._(`Date Filters - ${item.value}`);
                item.label = label || item.value;
                return item;
            });
        }
        return options;
    };

    calendarLocaleData = () => {
        const i18n = window.i18n;

        if (i18n) {
            return {
                'Label - StartDate': i18n._('Label - StartDate'),
                'Label - EndDate': i18n._('Label - EndDate'),
                'Label - Monday': i18n._('Label - Monday'),
                'Label - Sunday': i18n._('Label - Sunday')
            };
        }
        return {
            'Label - StartDate': 'Start Date',
            'Label - EndDate': 'End Date',
            'Label - Monday': 'Monday',
            'Label - Sunday': 'Sunday'
        };
    };

    render() {
        const {
            academicYear,
            currentDate,
            onDateChange,
            options,
            initialDate
        } = this.props;
        if (academicYear && currentDate && onDateChange) {
            return (
                <DatePickerTrans
                    currentDate={currentDate}
                    options={this.getTranslatedOptions(options)}
                    academicYear={academicYear}
                    onDateChange={onDateChange}
                    locale={localeCode()}
                    calendarLocaleData={this.calendarLocaleData()}
                    initialDate={initialDate}
                />
            );
        }
        return null;
    }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./components/date-picker/date-picker.js